import env from '../env/env'
import { get } from '../http/restservice'
import { getUserDetails } from './AuthUtil'

export const DEFAULT_PRIMARY_RM = {
  name: 'Fabits',
  role: 'Personal Finance Partner',
  roleDescription: 'Handles your portfolio allocation, fund selection, and investment strategy.',
  email: 'ajath.anjanappa@fabits.com',
  phone: '+91 80500 40838',
  type: 'PRIMARY_RM',
}

export const DEFAULT_SERVICE_RM = {
  name: 'Jeeva S',
  role: 'Client Success Partner',
  roleDescription: 'Assists with KYC onboarding, mandates, redemption queries, and support issues.',
  email: 'jeeva.s@fabits.com',
  phone: '+91 80500 40838',
  type: 'SERVICE_RM',
}

export const normalizeRmPhoneNumber = (phone = '') => phone.replace(/\D/g, '')

export const mapApiManagerToRm = (apiManager, fallback) => {
  if (!apiManager?.managerFullName && !apiManager?.managerPhoneNumber) {
    return fallback
  }

  return {
    ...fallback,
    name: (apiManager.managerFullName || fallback.name).trim(),
    email: apiManager.managerEmail || fallback.email,
    phone: apiManager.managerPhoneNumber || fallback.phone,
  }
}

export const fetchCustomerRelationshipDetails = async (clientCode) => {
  if (!clientCode) return null

  const response = await get(
    `${env.API_URL}customerservice/api/customerRM?clientCode=${clientCode}`,
  )

  if (!response || response?.isError) {
    return null
  }

  return response
}

export const getServiceRmFromCustomerDetails = (customerDetails) =>
  mapApiManagerToRm(customerDetails?.serviceRm, DEFAULT_SERVICE_RM)

export const fetchCurrentServiceRm = async () => {
  const userDetails = getUserDetails()
  const clientCode = userDetails?.uid?.split('-')[0]?.toUpperCase()
  const customerDetails = await fetchCustomerRelationshipDetails(clientCode)

  return getServiceRmFromCustomerDetails(customerDetails)
}

// Android WebViews cannot navigate to whatsapp:// (ERR_UNKNOWN_URL_SCHEME).
// Use an intent:// handoff on Android; elsewhere open the https chat link.
export const openWhatsAppChat = (phone) => {
  const normalizedPhone = normalizeRmPhoneNumber(phone)
  if (!normalizedPhone) return

  const ua = navigator.userAgent || ''
  const isAndroid = /Android/i.test(ua)
  const webUrl = `https://api.whatsapp.com/send?phone=${normalizedPhone}`

  if (isAndroid) {
    const intentUrl =
      `intent://send/?phone=${normalizedPhone}#Intent;` +
      'scheme=whatsapp;package=com.whatsapp;' +
      `S.browser_fallback_url=${encodeURIComponent(webUrl)};end`
    window.location.href = intentUrl
    return
  }

  const opened = window.open(webUrl, '_blank')
  if (!opened) {
    window.location.href = webUrl
  }
}
